import React from 'react';
import styles from "./index.module.scss";
import classNames from "classnames";
import { Col, Row } from "antd";

import { ReactComponent as HandIcon } from './images/hand-icon.svg';
import { ReactComponent as CashIcon } from './images/cash-icon.svg';
import { ReactComponent as InstantInkIcon } from './images/instant-ink-icon.svg';

import CashImg from './images/dollar-rgb-blue-nt.png';
import HandImg from './images/partnership-rgb-blue-nt.png';
import InstantInkImg from './images/i-ienvelope.png';

let cx = classNames.bind(styles);

const Benefits = (props) => (
    <div className={styles.benefits}>
        <div className={styles.benefitsHeading}>
            Life is easier with Instant Ink
        </div>
        <div className={styles.benefitsSubHeading}>
            Subscribe and enjoy the benefits of our service.
        </div>
        
        
        <Row type="flex" justify="center" align="middle">
            <Col md={7} lg={6} xl={5}>
                <div className={styles.benefitsItemIcon}>
                    <img src={InstantInkImg}/>
                </div>
            </Col>
            <Col md={{offset:1, span: 7}} lg={{offset: 1, span: 6}} xl={{offset: 1, span: 5}}>
                <div className={cx(styles.benefitsItemIcon, styles.cashImg)}>
                    <img src={CashImg}/>
                </div>
            </Col>
            <Col md={{offset:1, span: 7}} lg={{offset: 1, span: 6}} xl={{offset: 1, span: 5}}>
                <div className={cx(styles.benefitsItemIcon, styles.handImg)}>
                    <img src={HandImg}/>
                </div>
            </Col>
        </Row>
        
        <Row type="flex" justify="center">
            <Col md={7} lg={6} xl={5}>
                <div className={styles.benefitsItemHeader}>Never run out of ink <sup onClick={(evt) => { document.getElementById('footnote-1').scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"}); }}>1</sup></div>
                <div className={styles.benefitsItemTxt}>Your printer orders black and color ink for you and it’s delivered directly to your door. </div>
            </Col>
            <Col md={{offset:1, span: 7}} lg={{offset: 1, span: 6}}  xl={{offset: 1, span: 5}}>
                <div className={styles.benefitsItemHeader}>Spend half as much on ink <sup onClick={(evt) => { document.getElementById('footnote-2').scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"}); }}>2</sup></div>
                <div className={styles.benefitsItemTxt}>We’ve made it more efficient so you pay less—a lot less—to get the Original HP ink you want.</div>
            </Col>
            <Col md={{offset:1, span: 7}} lg={{offset: 1, span: 6}}  xl={{offset: 1, span: 5}}>
                <div className={styles.benefitsItemHeader}>Cancel anytime <sup onClick={(evt) => { document.getElementById('footnote-3').scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"}); }}>3</sup></div>
                <div className={styles.benefitsItemTxt}>We know commitment can be tough, so cancel or change your plan at anytime—there’s no contract.</div>
            </Col>
        </Row>
    </div>
);

export default Benefits;
